import styled from 'styled-components'

const Style = {
	TableDiv: styled.div`
		display: flex;
		flex-wrap: wrap;
		border-top: 1px solid ${({theme}) => theme.color.grey2};
	`,
	TableElement: styled.div`
		flex-basis: ${({$fullWidth}) => ($fullWidth ? '100%' : '50%')};
		flex-grow: 1;
		display: flex;
		border-bottom: 1px solid ${({theme}) => theme.color.grey2};

		& > h2 {
			display: flex;
			align-items: center;
			width: 200px;
			min-width: 200px;
			padding: 8px 16px;
			background-color: ${({theme}) => theme.color.grey1};
			${({theme}) => theme.font.extra_small_bold};

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				width: 160px;
				min-width: 160px;
				padding: 8px 10px;
			}
		}

		& > p {
			display: flex;
			align-items: center;
			flex-grow: 1;
			${({theme}) => theme.font.extra_small};
			padding: 8px 16px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				padding: 8px 10px;
			}
		}
	`,
	TableVerticalElement: styled.div`
		width: 100%;
		display: flex;
		border-bottom: 1px solid ${({theme}) => theme.color.grey2};

		& > h2 {
			display: flex;
			align-items: center;
			width: 200px;
			min-width: 200px;
			padding: 8px 16px;
			background-color: ${({theme}) => theme.color.grey1};
			${({theme}) => theme.font.extra_small_bold};
		}

		& > p {
			display: flex;
			align-items: center;
			flex-grow: 1;
			${({theme}) => theme.font.extra_small};
			padding: 8px 16px;
		}
	`,
	TableUserDetail: styled.div`
		display: flex;
		flex-wrap: wrap;
		border-top: 1px solid ${({theme}) => theme.color.grey2};
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			flex-direction: column;
		}
	`,
	TableElementUserDetail: styled.div`
		flex-basis: 50%;
		flex-grow: 1;
		display: flex;
		border-bottom: 1px solid ${({theme}) => theme.color.grey2};

		& > h2 {
			display: flex;
			align-items: center;
			width: 200px;
			min-width: 200px;
			padding: 8px 16px;
			background-color: ${({theme}) => theme.color.grey1};
			${({theme}) => theme.font.extra_small_bold};

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				width: 120px;
				min-width: 120px;
				padding: 8px 10px;
			}
		}

		& > p {
			display: flex;
			align-items: center;
			flex-grow: 1;
			${({theme}) => theme.font.extra_small};
			padding: 8px 16px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				padding: 8px 10px;
			}
		}
	`,
}

export default Style
